import { render, staticRenderFns } from "./UserDetailPremiumComment.vue?vue&type=template&id=42929b39&scoped=true"
import script from "./UserDetailPremiumComment.vue?vue&type=script&lang=js"
export * from "./UserDetailPremiumComment.vue?vue&type=script&lang=js"
import style0 from "./UserDetailPremiumComment.vue?vue&type=style&index=0&id=42929b39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42929b39",
  null
  
)

export default component.exports